import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Less = () => {
  return (
    <StartInterviewLayout type="less"/>
  )
}

export default Less;